// extracted by mini-css-extract-plugin
export default {"maindiv":"UserCard_maindiv__VZ8+7","user_name":"UserCard_user_name__jT+5O","user_type":"UserCard_user_type__8V9GB","modal":"UserCard_modal__VozgQ"};